export default __webpack_public_path__ + "locales/tr/PeopleTranslations.json?hash=dfe85611d0f3a2454cd5b35688e53cf5";